/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvbGFudGFnby1hcHAvbGFudGFnby1hcHAtZGVtby9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2Zvcm1zL2lucHV0LWZpZWxkL2lucHV0LWZpZWxkLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9sYW50YWdvLWFwcC9sYW50YWdvLWFwcC1kZW1vL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvZm9ybXMvaW5wdXQtZmllbGQvaW5wdXQtZmllbGQuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/$$_gendir/app/shared/components/forms/input-field/input-field.component.css.shim.ngstyle.ts